import { render } from "./NewEv.vue?vue&type=template&id=445f1c7c&scoped=true"
import script from "./NewEv.vue?vue&type=script&lang=js"
export * from "./NewEv.vue?vue&type=script&lang=js"

import "./NewEv.vue?vue&type=style&index=0&id=445f1c7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445f1c7c"]])

export default __exports__